<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="taskCommCdRows"
		selection
		:excel="isButton_(scrId, 'EX')"
		paging
		@changedPage="onChangePage"
		v-bind="taskCommCdPagingInfo"
		:pageUnit="taskCommCdPagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="taskCommCdPagingInfo.totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addRow">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
				getMessage_('MWCC000138')
			}}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import * as yup from 'yup';
import { serviceMethods, serviceComputed } from '@/views/cc/CommonCode/store/helpers';
import { serviceTaskMethods, serviceTaskComputed } from '@/views/qms/TaskCommCd/store/helpers';
import { rootComputed } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		...serviceTaskComputed,
		options() {
			return this.useYnOptions.slice(1, 3);
		},
		rows() {
			return this.taskCommCdRows;
		},
		columns() {
			return [
				{ label: 'No.', prop: 'rnum', width: '130px' },
				{ label: this.getMessage_('MWCC000141'), prop: 'status', width: '150px' },
				{ label: this.getMessage_('MWCC000142'), prop: 'mstCd', width: '200px' },
				{
					label: this.getMessage_('MWCC000150'),
					prop: 'dtlCd',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('MWCC000151'),
					prop: 'dtlCdName',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('MWCC000152'),
					prop: 'dtlCdDesc',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 1000
					}
				},
				{
					label: this.getMessage_('MWCC000144'),
					prop: 'dtlCdSeq',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('MWCC000159'),
					prop: 'ref1Cd',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('MWCC000160'),
					prop: 'ref2Cd',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				// ref2Cd 더있다
				{
					label: this.getMessage_('MWCC000145'),
					prop: 'useYn',
					width: '200px',
					form: {
						type: 'select',
						options: this.options
					}
				},
				{ label: this.getMessage_('MWCC000146'), prop: 'regDt', width: '250px' },
				{ label: this.getMessage_('MWCC000005'), prop: 'regId', width: '200px' },
				{ label: this.getMessage_('MWCC000171'), prop: 'chgDt', width: '250px' },
				{ label: this.getMessage_('MWCC000172'), prop: 'chgId', width: '200px' }
			];
		},
		commCdSchema() {
			return yup.object().shape({
				mstCd: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('MWCC000175'), [this.getMessage_('MWCC000168')]))
					.min(1, this.$sf_formatString(this.getMessage_('MWCC000176'), [this.getMessage_('MWCC000168'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000168'), 20])),
				dtlCd: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('MWCC000175'), [this.getMessage_('MWCC000150')]))
					.min(1, this.$sf_formatString(this.getMessage_('MWCC000176'), [this.getMessage_('MWCC000150'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000150'), 20])),
				dtlCdName: yup
					.string()
					.trim()
					.default('')
					.min(1, this.$sf_formatString(this.getMessage_('MWCC000176'), [this.getMessage_('MWCC000151'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000151'), 20])),
				dtlCdDesc: yup
					.string()
					.trim()
					.default('')
					.max(200, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000152'), 200])),
				useYn: yup.string().trim().default('Y')
			});
		}
	},
	methods: {
		...serviceMethods,
		...serviceTaskMethods,
		isAdded: ({ row }) => row.status !== 'I',
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.searchTaskCommCd_({ currentPage: currentPageVal, pageUnit: pageUnitVal, mstCd: this.currentMstCd }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		},
		addRow() {
			if (!this.currentMstCd) {
				return;
			}
			const selectedRows = this.$refs.table.getSelectedRows();
			const toggleRowSelection = this.$refs.table.getTable().toggleRowSelection;
			this.addTaskCommCdRow_().then(addedRow => {
				selectedRows.push(addedRow);
				selectedRows.forEach(row => {
					toggleRowSelection(row);
				});
			});
			this.$refs.table.scrollBottom();
		},
		getSelectedRows() {
			const defaultObj = this.commCdSchema.cast();
			const rows = this.$refs.table
				.getSelectedRows()
				.map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value());
			return rows;
		},
		async onClickButton(action) {
			const selectedRows = this.getSelectedRows();
			if (!selectedRows || selectedRows.length === 0) {
				const errMsg = this.getMessage_(action === 'save' ? 'MWCC000434' : 'MWCC000418');
				this.$sf_toast({ type: 'error', message: errMsg, option: { duration: 3000 } });
				return;
			}
			const messageCode = {
				save: 'MWCC000501',
				delete: 'MWCC000108'
			}[action];
			const clickFn = {
				save: this.saveTaskCommCd,
				delete: this.deleteTaskCommCd
			}[action];
			await this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_(messageCode),
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('MWCC000203')
			});
		},
		async saveTaskCommCd() {
			const selectedRows = this.getSelectedRows();
			const fail = (
				await Promise.all(
					selectedRows.map(row =>
						this.commCdSchema
							.validate(row)
							.then(() => ({ isValid: true }))
							.catch(e => ({ isValid: false, ...e }))
					)
				)
			).filter(r => !r.isValid);
			if (fail.length > 0) {
				this.$sf_showMessage({ icon: 'error', message: fail[0].message });
				return;
			}
			this.$sf_toggleLoading(true);
			this.saveTaskCommCd_(selectedRows)
				.then(({ code, message }) =>
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message
					})
				)
				.finally(() => this.$sf_toggleLoading(false));
		},
		deleteTaskCommCd() {
			this.$sf_toggleLoading(true);
			this.deleteTaskCommCd_(this.getSelectedRows())
				.then(res => res && this.$sf_toast({ ...res, type: res.code === 0 ? 'ok' : 'error' }))
				.finally(() => this.$sf_toggleLoading(false));
		}
	},
	watch: {
		rows() {
			const target = _.first(this.$refs.table.$el.getElementsByClassName('el-table__body-wrapper')) || {};
			target.scrollLeft = 0;
		}
	}
};
</script>
